'use client'

import { useState } from 'react'
import TruecallerLogin from '../components/TruecallerLogin'
import UserForm from '../components/UserForm'
import AdminPanel from '../components/AdminPanel'
import NumdleGame from '../components/NumdleGame'
import { API_BASE_URL } from '../lib/config'

export default function Home() {
  const [authenticated, setAuthenticated] = useState(false)
  const [sessionData, setSessionData] = useState(null)
  const [sessionId, setSessionId] = useState(null)
  const [showGame, setShowGame] = useState(false)
  
  const isAdmin = sessionData?.isAdmin === true

  const handleAuthenticated = (userData, sid) => {
    setSessionData(userData)
    setSessionId(sid)
    setAuthenticated(true)
  }

  const handleSubmit = async (data) => {
    try {
      const { protectedFetch } = await import('../lib/recaptcha')
      
      const response = await fetch(`${API_BASE_URL}/api/users/save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...data, sessionId }),
        action: 'save_profile'
      })

      if (response.ok) {
        alert('Profile saved successfully!')
      } else {
        const error = await response.json()
        alert(`Error: ${error.error}`)
      }
    } catch (error) {
      console.error('Save error:', error)
      alert('Failed to save profile')
    }
  }

  const handleLogout = () => {
    localStorage.removeItem('numdle_session')
    setAuthenticated(false)
    setSessionData(null)
    setSessionId(null)
  }

  return (
    <main style={{ padding: '2rem', fontFamily: 'system-ui' }}>
      <a 
        href="https://github.com/theabbie/Numdle" 
        target="_blank" 
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          top: '1rem',
          right: '1rem',
          fontSize: '0.75rem',
          color: '#666',
          textDecoration: 'none',
          padding: '0.25rem 0.5rem',
          borderRadius: '4px',
          background: '#f5f5f5',
          zIndex: 1000
        }}
      >
        GitHub
      </a>
      <div style={{ maxWidth: '600px', margin: '0 auto' }}>
        <h1 style={{ marginBottom: '0.5rem', textAlign: 'center' }}>Numdle</h1>
        <p style={{ marginBottom: '2rem', color: '#666', textAlign: 'center' }}>
          Wordle-like game for guessing phone numbers and meeting people
        </p>
        
        {!authenticated ? (
          <TruecallerLogin onAuthenticated={handleAuthenticated} />
        ) : (
          <>
            <div style={{ 
              marginBottom: '1rem', 
              padding: '0.75rem', 
              background: '#f0fdf4', 
              borderRadius: '8px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <span style={{ fontSize: '14px', color: '#166534' }}>
                ✓ Logged in as {sessionData?.phone}
              </span>
              <button
                onClick={handleLogout}
                style={{
                  padding: '0.25rem 0.75rem',
                  background: 'transparent',
                  border: '1px solid #166534',
                  borderRadius: '4px',
                  color: '#166534',
                  fontSize: '12px',
                  cursor: 'pointer'
                }}
              >
                Logout
              </button>
            </div>
            {!showGame ? (
              <>
                <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                  <button
                    onClick={() => setShowGame(true)}
                    style={{
                      padding: '1rem 2rem',
                      fontSize: '1.2rem',
                      fontWeight: 'bold',
                      backgroundColor: '#3b82f6',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                  >
                    🎮 Play Numdle Game
                  </button>
                </div>

                <UserForm 
                  onSubmit={handleSubmit} 
                  sessionData={sessionData}
                  sessionId={sessionId}
                />
                
                {isAdmin && <AdminPanel sessionId={sessionId} />}
              </>
            ) : (
              <>
                <button
                  onClick={() => setShowGame(false)}
                  style={{
                    marginBottom: '1rem',
                    padding: '0.5rem 1rem',
                    backgroundColor: '#6b7280',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  ← Back to Profile
                </button>
                <NumdleGame sessionId={sessionId} />
              </>
            )}
          </>
        )}
      </div>
    </main>
  )
}
